import { apiFormDataRequest, apiGetRequest, apiPostRequest } from "helpers/Requests";
import { URL_PLATFORM_ADMIN_EVENTS, URL_SP_EVENTS } from "store/services/URL";

const eventsFromResponse = (response) =>
  response?.data?.data?.events?.data || [];

export async function fetchFeedEvents({ admin = false } = {}) {
  const endpoint = admin ? URL_PLATFORM_ADMIN_EVENTS : URL_SP_EVENTS;
  const response = await apiGetRequest(`${endpoint}/list?page=1&per_page=50`);

  if (response?.status !== 200) {
    throw new Error(response?.data?.message || "Failed to load events");
  }

  return eventsFromResponse(response);
}

export async function saveFeedEvent({ uuid, title, description, imageFile }) {
  const payload = new FormData();
  payload.append("title", title);
  payload.append("description", description || "");

  if (uuid) {
    payload.append("uuid", uuid);
  }

  if (imageFile) {
    payload.append("image", imageFile);
  }

  const endpoint = uuid
    ? `${URL_PLATFORM_ADMIN_EVENTS}/update`
    : `${URL_PLATFORM_ADMIN_EVENTS}/store`;
  const response = await apiFormDataRequest(endpoint, payload);

  if (response?.status !== 200 && response?.status !== 201) {
    const error = new Error(
      response?.data?.message || response?.data?.error || "Failed to save event"
    );
    error.response = response;
    throw error;
  }

  return response?.data?.data?.event ?? null;
}

export async function deleteFeedEvent(uuid) {
  const response = await apiPostRequest(`${URL_PLATFORM_ADMIN_EVENTS}/delete`, {
    uuid,
  });

  if (response?.status !== 200) {
    throw new Error(response?.data?.message || "Failed to delete event");
  }
}
